import React from "react";
import { PercentageOutlined } from "@ant-design/icons";

const couponTitle = (props) => {
  return (
    <div>
      {" "}
      <div className="coupon-title-wrap ">
        <div className="percent-icn">
          <PercentageOutlined />
        </div>
        <div className="coupon-title">{props.title}</div>
      </div>
    </div>
  );
};

export default couponTitle;
